import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { formatShortWeekDayMonthDay, OwaDate, subDays } from 'owa-datetime';
import loc from 'owa-localize';
import { isToday } from 'owa-observable-datetime';
import * as React from 'react';
import {
    agendaListDateHeaderTodayText,
    agendaListDateHeaderTomorrowText,
} from './AgendaListDateHeader.locstring.json';

import styles from './AgendaListDateHeader.scss';

export interface AgendaListDateHeaderProps {
    date: OwaDate;
}

export const AgendaListDateHeader = observer(function AgendaListDateHeader(
    props: AgendaListDateHeaderProps
) {
    const dateText = formatShortWeekDayMonthDay(props.date);

    const isDateToday = isToday(props.date);
    const isDateTomorrow = isToday(subDays(props.date, 1));
    let contextualDateText = '';
    if (isDateToday) {
        contextualDateText = loc(agendaListDateHeaderTodayText);
    } else if (isDateTomorrow) {
        contextualDateText = loc(agendaListDateHeaderTomorrowText);
    }

    return (
        <div title={dateText} className={styles.header}>
            <span className={styles.date}>
                {contextualDateText}
                {contextualDateText && (
                    <Icon className={styles.dotIcon} iconName={ControlIcons.LocationDot} />
                )}
                {dateText}
            </span>
        </div>
    );
});
